import type { CSSProperties } from 'react';

import { IDropdownMenuProps } from '../../../interfaces/globals';
import type { DropdownPlacement } from '../../../types/globals';

import './DropdownMenu.scss';

const PLACEMENT_STYLES: Record<DropdownPlacement, CSSProperties> = {
  top: { bottom: 'calc(100% + 4px)', left: '50%', transform: 'translateX(-50%)' },
  bottom: { top: 'calc(100% + 4px)', left: '50%', transform: 'translateX(-50%)' },
  left: { right: 'calc(100% + 4px)', top: '50%', transform: 'translateY(-50%)' },
  right: { left: 'calc(100% + 4px)', top: '50%', transform: 'translateY(-50%)' }
};

const DropdownMenu = ({ items, placement = 'bottom' }: IDropdownMenuProps) => (
  <div className="dropdown-menu" style={PLACEMENT_STYLES[placement]}>
    {items.map((item) => (
      <button
        key={item.key}
        className={`dropdown-menu__item${item.active ? ' dropdown-menu__item--active' : ''}`}
        onClick={item.onClick}
        type="button"
      >
        {item.icon && <span className="dropdown-menu__icon">{item.icon}</span>}
        {item.label}
      </button>
    ))}
  </div>
);

export default DropdownMenu;
